// TODO: Name this file something better
import {
	StarterKit,
	Subscript,
	Superscript,
	TextAlign,
	Underline,
	Link,
	FontSize,
	TextAround,
} from '$textEditor/Extensions';
import HubsMention from '$textEditor/Extensions/Mentions/mention';
import { PluginKey } from '@tiptap/pm/state';

// For some reason this do not work after build, if its not wrapped in a function
export const textExtensions = () => {
	return [
		StarterKit.configure({
			heading: {
				levels: [1, 2],
				HTMLAttributes: {
					datatype: 'block',
				},
			},
			paragraph: {
				HTMLAttributes: {
					datatype: 'block',
				},
			},
			codeBlock: {
				HTMLAttributes: {
					datatype: 'block',
				},
			},
		}),
		Subscript,
		Superscript,
		FontSize.configure({
			types: ['heading', 'paragraph', 'codeBlock'],
		}),
		TextAlign.configure({
			types: ['heading', 'paragraph', 'codeBlock'],
		}),
		Underline,
		Link.configure({
			autolink: false,
			openOnClick: false,
			linkOnPaste: true,
		}),
		TextAround,
		HubsMention.configure({
			suggestion: {
				pluginKey: new PluginKey('mentionTextExtension'),
			},
		}),
	];
};
